import { reactive } from 'vue'
import { defineStore } from 'pinia'
import type { Benutzer } from '@/models/Benutzer'


export const useStore = defineStore('main', () => {
  const state = reactive<{
    session: boolean;
    appVersion: string,
    webroot: string,
    loading: boolean,
    loadingCounter: number,
    snackbarContent: string,
    redirectUrl: string,
    customer: string,
    config: { gueltigkeit_zusage_deadline: number, env?: string } | null,
    benutzer: Benutzer | null
  }>({
    session: false,
    appVersion: '',
    webroot: '',
    loading: false,
    loadingCounter: 0,
    snackbarContent: '',
    redirectUrl: '/',
    customer: 'default',
    config: null,
    benutzer: null
  });

  function isAuthenticated() {
    return state.benutzer !== null
  }

  function isAdmin() {
    return state.benutzer?.rolle === 'admin'
  }

  function getBenutzer() {
    return state.benutzer
  }

  return { state, isAuthenticated, isAdmin, getBenutzer }
})
